module.exports = __webpack_public_path__ + "media/images/workplace/instructions/anBtn-e898bd421276f548d4840013ad3bf60d.png";